import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { Box, Paper, Stack, Typography } from "@mui/material";
import type { ArtifactActionHandlers } from "./ArtifactActions";
import ArtifactTile from "./ArtifactTile";
import { getOneLineTileGridSx } from "./artifactTileGrid";
import type { RecentArtifactTile } from "./recentArtifacts";

interface Props extends ArtifactActionHandlers {
  tiles: RecentArtifactTile[];
  canManage: boolean;
  selectedIds: ReadonlySet<string>;
  observerRoot?: Element;
  onToggleSelected: (artifactId: string) => void;
  onToggleFavorite: (artifactId: string) => void;
}

const RecentArtifactsCard = ({ tiles, canManage, selectedIds, observerRoot, ...tileHandlers }: Props) => (
  <Paper variant="outlined" sx={{ px: (theme) => `calc(${theme.spacing(2)} - 1px)`, pt: 1.5, pb: 2 }}>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 1.5 }}>
      <HistoryRoundedIcon color="secondary" />
      <Typography variant="subtitle1">Recent</Typography>
    </Stack>
    <Box sx={getOneLineTileGridSx(tiles.length)}>
      {tiles.map(({ row, openedAt }) => (
        <ArtifactTile
          key={row.id}
          artifact={row}
          openedAt={openedAt}
          canManage={canManage}
          isSelected={selectedIds.has(row.id)}
          observerRoot={observerRoot}
          {...tileHandlers}
        />
      ))}
    </Box>
  </Paper>
);

export default RecentArtifactsCard;
